export interface DmsEnrollmentFinalizationStep<Key extends string> {
  key: Key;
  run: () => Promise<boolean> | boolean;
}

export interface DmsEnrollmentFinalizationResult<Key extends string> {
  completed: boolean;
  failedStep?: Key;
}

export const runDmsEnrollmentFinalization = async <Key extends string>(
  steps: DmsEnrollmentFinalizationStep<Key>[],
  startStep?: Key
): Promise<DmsEnrollmentFinalizationResult<Key>> => {
  const startIndex = startStep ? steps.findIndex((step) => step.key === startStep) : 0;

  if (startIndex < 0) {
    throw new Error(`Unknown DMS enrollment finalization step: ${startStep}`);
  }

  for (let index = startIndex; index < steps.length; index++) {
    const step = steps[index];
    const didSucceed = await step.run();

    if (!didSucceed) {
      return {
        completed: false,
        failedStep: step.key,
      };
    }
  }

  return {
    completed: true,
  };
};
